import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { isIOS } from 'react-device-detect';
import { Button, Loading } from 'carbon-components-react';
import { ArrowUp16 } from '@carbon/icons-react';
import { connect } from 'react-redux';
import { CFCProps, SCREEN_SIZE, APP_URL } from 'types';
import { MainContainer } from 'layouts/components';
import _ from 'lodash';
import CLOModalDetails from '../enquiryDetailsNew/components/AboutAndADS/CLOModalDetails';
import OldCLOModalSection from '../enquiryDetailsNew/components/AboutAndADS/OldCLOModalSection';
import OldCLOModalListing from '../enquiryDetailsNew/components/AboutAndADS/OldCLOModalListing';
import OldCLOModalDetails from '../enquiryDetailsNew/components/AboutAndADS/OldCLOModalDetails';
import CLOModalSection from '../enquiryDetailsNew/components/AboutAndADS/CLOModalSection';
import { fetchEnquiryById } from 'redux/enquiries';
import { useDispatch, useSelector } from 'react-redux';
import { selectedEnquiry } from 'redux/enquiries/selectors';
import {
  selectScreenSize,
  selectIsAuthenticated
} from 'redux/session/selectors';
import { selectAuthError } from 'redux/auth/selectors';
import { resetLoginError } from 'redux/auth/action';

const connector = connect();
type Props = CFCProps<typeof connector>;

interface RouteParams {
  enquiryId: string;
}

export const CertLocLocator: React.FC<Props | any> = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { enquiryId } = useParams<RouteParams>();
  const enquiry = useSelector(selectedEnquiry);
  const screenSize = useSelector(selectScreenSize);
  const authError = useSelector(selectAuthError);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  const [toShow, setToShow] = useState<string>('enquiryDetails');
  const [CLODetailsId, setCLODetailsId] = useState<number>(0);
  const [from, setFrom] = useState<string>('');
  const [searchText, setSearchText] = useState<any>('');
  const [order, setOrder] = useState<string>('1');
  const [withHidden, setWithHidden] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageOffset, setPageOffset] = useState<number>(0);
  const [querySeed, setQuerySeed] = useState<string>('');
  const [hasRedirected, setHasRedirected] = useState<boolean>(false);
  const [addressState, setAddressState] = useState<string[]>([]);

  useEffect(() => {
    if (authError && !hasRedirected) {
      setHasRedirected(true);
      dispatch(resetLoginError());

      if (isAuthenticated) {
        history.replace(APP_URL.DASHBOARD);
      } else {
        history.replace({
          pathname: APP_URL.LOGIN,
          state: { from: history.location }
        });
      }
    }
  }, [authError, isAuthenticated, history, hasRedirected, dispatch]);

  useEffect(() => {
    if (enquiryId && !enquiry) {
      dispatch(fetchEnquiryById({ enquiryId, logo: true }));
    }
  }, [enquiryId, enquiry, dispatch]);

  useEffect(() => {
    if (!_.isEmpty(enquiry)) {
      const availableAddressStates = [
        'ACT',
        'NSW',
        'NT',
        'QLD',
        'SA',
        'TAS',
        'VIC',
        'WA'
      ];
      const defaultAddressState = availableAddressStates.includes(
        enquiry.Address?.state
      )
        ? enquiry.Address?.state === 'ACT' || enquiry.Address?.state === 'NSW'
          ? ['ACT']
          : [enquiry?.Address?.state]
        : [];

      setAddressState(defaultAddressState);
    }
  }, [enquiry]);

  const goToMyEnquiryPage = () => {
    history.push(`/enquiries/${enquiryId}`);
  };

  const goToTop = () => {
    const ele = document.getElementById('enquiryDetails');
    if (ele) {
      ele.scrollIntoView();
    }
  };

  const changeView = (view: string) => {
    setToShow(view);
  };

  const handleBackButtonClick = () => {
    setCLODetailsId(0);
    if (from === 'listing') {
      changeView('cloListing');
    } else {
      changeView('enquiryDetails');
    }
    setFrom('');
  };

  const handleCLOTileClick = (cloId: number) => {
    setCLODetailsId(cloId);
    changeView('cloDetails');
  };

  const handleCLOViewDetailsClick = (cloId: number, from: string = '') => {
    setCLODetailsId(cloId);
    changeView('cloDetails');
    setFrom(from);
  };

  const handleSeeALLCLOButtonClick = () => {
    changeView('cloListing');
  };

  // page heading title
  let pageHeadingTitle = '';
  if (toShow === 'enquiryDetails') {
    pageHeadingTitle = 'Find a Locator';
  } else if (toShow === 'cloDetails') {
    pageHeadingTitle = 'Certified Locating Organisation';
  } else if (toShow === 'cloListing') {
    pageHeadingTitle = 'All Certified Locating Organisations';
  }

  if (authError || !enquiry) {
    return <Loading withOverlay={true} />;
  }

  return (
    <div className="certloc-locator-page">
      <div
        id="enquiryDetails"
        data-testid="enquiryDetails"
        className="enquiryDetails--wrapper container--wrapper"
      >
        <MainContainer>
          <div className="main-wrapper">
            <div className={`left-content${isIOS ? ' is-ios' : ''}`}>
              <div className="page-header">
                <h1>{pageHeadingTitle}</h1>
              </div>

              {toShow === 'enquiryDetails' && enquiry && (
                <React.Fragment>
                  {process.env.REACT_APP_CLO_MODAL_VERSION === 'old' ? (
                    <OldCLOModalSection
                      screenSize={screenSize}
                      handleCLOTileClick={handleCLOTileClick}
                      handleSeeALLCLOButtonClick={handleSeeALLCLOButtonClick}
                      enquiryDetail={enquiry}
                      querySeed={querySeed}
                      setQuerySeed={setQuerySeed}
                      currentView={toShow}
                      isModalOpen={true}
                    />
                  ) : (
                    <CLOModalSection
                      enquiryDetail={enquiry}
                      handleCLOViewDetailsClick={handleCLOViewDetailsClick}
                      searchText={searchText}
                      setSearchText={setSearchText}
                      addressState={addressState}
                      setAddressState={setAddressState}
                      order={order}
                      setOrder={setOrder}
                      screenSize={screenSize}
                      withHidden={withHidden}
                      setWithHidden={setWithHidden}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      pageOffset={pageOffset}
                      setPageOffset={setPageOffset}
                    />
                  )}
                </React.Fragment>
              )}

              {toShow === 'cloDetails' && (
                <React.Fragment>
                  {process.env.REACT_APP_CLO_MODAL_VERSION === 'old' ? (
                    <OldCLOModalDetails
                      handleBackButtonClick={handleBackButtonClick}
                      CLODetailsId={CLODetailsId}
                    />
                  ) : (
                    <CLOModalDetails
                      handleBackButtonClick={handleBackButtonClick}
                      CLODetailsId={CLODetailsId}
                    />
                  )}
                </React.Fragment>
              )}

              {toShow === 'cloListing' && (
                <React.Fragment>
                  <OldCLOModalListing
                    handleBackButtonClick={handleBackButtonClick}
                    enquiryDetail={enquiry}
                    handleCLOViewDetailsClick={handleCLOViewDetailsClick}
                    searchText={searchText}
                    setSearchText={setSearchText}
                    order={order}
                    setOrder={setOrder}
                    screenSize={screenSize}
                    withHidden={withHidden}
                    setWithHidden={setWithHidden}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    pageOffset={pageOffset}
                    setPageOffset={setPageOffset}
                    isStandloneCLOListing={false}
                    goToMyEnquiryPage={goToMyEnquiryPage}
                    querySeed={querySeed}
                    setQuerySeed={setQuerySeed}
                  />
                </React.Fragment>
              )}

              <div className="bottom-menu">
                <div className="bottom-menu-top-button">
                  {screenSize !== SCREEN_SIZE.SM ? (
                    <Button
                      kind={'ghost'}
                      renderIcon={ArrowUp16}
                      onClick={goToTop}
                      iconDescription="Go to top"
                    >
                      TOP
                    </Button>
                  ) : (
                    <Button
                      kind={'tertiary'}
                      renderIcon={ArrowUp16}
                      iconDescription="Go to top"
                      onClick={goToTop}
                      hasIconOnly
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </MainContainer>
      </div>
    </div>
  );
};

export default connector(CertLocLocator);
